module.exports = __webpack_public_path__ + "img/milliyet.e8be7762.png";